import { TENDER_REDIRECT, TOKEN_KEY } from '@constants';
import { userInfo } from '@store/index';
import {
  clearStorage,
  getStorage,
  setStorage
} from '@utils/localStorageService';
import { useEffect } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useRecoilState } from 'recoil';
/**
 * 处理路由权限
 * @param
 * */

const AuthRouter = (props: { children: JSX.Element }) => {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const [searchParams] = useSearchParams();
  const [userInfoFromStore] = useRecoilState(userInfo);

  useEffect(() => {
    // 这里判断token是否存在以及authority和roleList
    // 记得打开 ⭐⭐⭐
    const uriData = searchParams.get('resource');
    if (
      !getStorage(TOKEN_KEY) ||
      !userInfoFromStore?.authority ||
      !userInfoFromStore?.roleList
    ) {
      clearStorage(TOKEN_KEY);
      if (pathname !== '/login') {
        setStorage(TENDER_REDIRECT, `${pathname}${search}`);
      }

      if (uriData) {
        navigate(`/login?resource=${uriData}`);
      } else {
        if (!pathname.includes('/confirmation')) {
          navigate('/login');
        }
      }
      return;
    }
    // 这里判断条件是：token 存在并且是匹配到路由并且是已经登录的状态
    // if (getStorage(TOKEN_KEY)) {
    //   // 如果你已经登录了，但是你通过浏览器里直接访问login的话不允许直接跳转到login路由，必须通过logout来控制退出登录或者是token过期返回登录界面
    //   if (pathname === '/' || pathname === '/login') {
    //     navigate('/login');
    //     return;
    //   }
    // }
  }, [userInfoFromStore]);
  return props.children;
};
export default AuthRouter;
